import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const reminderScheduleConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default reminderScheduleConfig;
